import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';

import { PermitSearchContainer } from '@ruby/shared/dialogs/unit-train/permit-search-dialog/containers/permit-search.container';

@Component({
  selector: 'ng-permit-single',
  templateUrl: './permit-single.component.html',
  styleUrls: ['./permit-single.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitSingleComponent implements OnChanges {
  @Input() permits!: Array<{ name: string; title?: string; permitType?: string }>;
  @Input() selectedPermit?: string;
  @Output() addPermit = new EventEmitter();
  @Output() removePermit = new EventEmitter<string>();
  @ViewChild(MatTabGroup) permitsTabGroup!: MatTabGroup;

  constructor(private matDialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedPermit && changes.selectedPermit.currentValue && this.selectedPermit) {
      this.permitsTabGroup.selectedIndex = this.permits.findIndex((perm: { name: string }) => perm.name === this.selectedPermit);
    }
  }

  /**
   * Emit Add Permit
   *
   * @summary emit an event to update the state to add a permit
   * @return void
   */
  emitAddPermit(): void {
    this.addPermit.emit();
    this.setLastTabSelected();
  }

  /**
   * Emit Remove Permit
   *
   * @summary emit an event to update the state to remove a permit
   * @param permit: IUTPermit
   * @return void
   */
  emitRemovePermit(permit: { name: string }): void {
    const idx = this.permits.indexOf(permit);
    const selectedIdx = (idx > 0) ? idx - 1 : 0;
    this.removePermit.emit(permit.name);
    this.setTabSelected(selectedIdx);
  }

  /**
   * Show Permit Search Dialog
   *
   * @summary shows the permit search dialog
   * @return void
   */
  showPermitSearchDialog(): void {
    this.matDialog.open(PermitSearchContainer, { width: '30vw' })
      .afterClosed().subscribe((permit: { permitName: string }) => {
      if (permit) {
        this.permitsTabGroup.selectedIndex = this.permits.findIndex((perm: { name: string }) => perm.name === permit.permitName);
      }
    });
  }

  /**
   * Track By Id
   *
   * @summary Track By Id function used by *NgFor to optimize render
   * @param index: number
   * @param item: { name: string }
   * @return void
   */
  trackById(index: number, item: { name: string }): string {
    return item.name;
  }

  private setLastTabSelected(): void {
    setTimeout(() => { this.permitsTabGroup.selectedIndex = this.permits.length - 1; });
  }

  private setTabSelected(idx: number): void {
    setTimeout(() => { this.permitsTabGroup.selectedIndex = idx; });
  }
}
